import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';

export const fetchLocationsList = (warehouse = 'CPD') => apiActionCreator({
  'endpoint': `/warehouses/locations?warehouse=${warehouse}`,
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_LOCATIONS_LIST,
    ActionTypes.FETCHED_LOCATIONS_LIST,
    [
      ActionTypes.FETCHED_LOCATIONS_LIST_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const filterLocations = (value) => ({
  'type': ActionTypes.FILTER_LOCATIONS,
  'payload': value,
});

export const changeLocationsTextFilter = (value) => ({
  'type': ActionTypes.CHANGE_LOCATIONS_TEXT_FILTER,
  'payload': value,
});

export const changeLocationsListPage = (value) => ({
  'type': ActionTypes.CHANGE_LOCATIONS_LIST_PAGE,
  'payload': value,
});

export const changeLocationsListPageSize = (value) => ({
  'type': ActionTypes.CHANGE_LOCATIONS_LIST_PAGE_SIZE,
  'payload': value,
});
